/**
 * @group Data
 * @summary Operation descriptions for error handling
 * 
 * @remarks
 * This constant contains operation descriptions used in database error handling
 * to provide context about what operation was being performed when an error occurred.
 * 
 * @example
 * ```typescript
 * import { DATA_OPERATIONS } from '@shared/constants';
 * 
 * try {
 *   await updateUser(userId, data);
 * } catch (error) {
 *   logger.error(`Error ${DATA_OPERATIONS.UPDATING_USER}:`, error);
 * }
 * ```
 */
export const DATA_OPERATIONS = {
  FETCHING_USER: 'fetching user',
  UPDATING_USER: 'updating user',
  DELETING_USER: 'deleting user'
} as const; 